import { createRouter, createWebHistory } from 'vue-router';
import { routes } from './routes';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    const main = document.getElementById("main");
    if(main) main.scrollTop = -100;
  },
});

router.beforeEach((to, from, next) => {
  if (to.fullPath.includes("?phoneNumber=")) {
    next({
      name: 'abrof.subscribe', 
      params: { num: to.query.phoneNumber }
    });
  } else {
    next();
  }
});

export default router;
